import React, { useContext, useState, useEffect, useRef } from 'react';

const Checkbox = ({ value, isChecked, disabled, label, checkHandler, index }) => {
	//console.log({ isChecked })
	return (
		<>
			<input
				onChange={checkHandler}
				className={`form-check-input`}
				type="checkbox"
				value={value}
				disabled={disabled}
				checked={isChecked}
				id={`choice-${index}`} />
			<label className="form-check-label ms-1" htmlFor={`choice-${index}`} dangerouslySetInnerHTML={{ __html: label }}>
			</label>
		</>
	)
}

export default Checkbox;
